import styled from 'styled-components'

export const SavedVideosBgContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: none;
`

export const NonHeaderContainer = styled.div`
  display: flex;
  height: 100%;
`
